import React from "react";
import AdmMentorStudentDetails from "../../components/AdminTabs/AdminAssignMentor/AdmMentorStudentDetails";

const AddStudent = () => {
  return (
    <div>
      <AdmMentorStudentDetails/>
    </div>
  );
};

export default AddStudent;
